/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * type of diffusion:
 *   * STANDARD
 *   * TICKETING
 */
export enum DiffusionListType {
  STANDARD = 'STANDARD',
  TICKETING = 'TICKETING'
}
